import { MultiSelect } from 'src/design/atoms/MultiSelect';
import React from 'react';

import { DivisionDto, OrganizationOfficeDto } from 'src/api/FiretrolApiClient';

interface IOfficeDivisionSelectorProps {
  onChange: (divisions: DivisionDto[]) => void;
  offices: OrganizationOfficeDto[];
  value?: DivisionDto[];
  disabled?: boolean;
}

export const OfficeDivisionSelector: React.FC<IOfficeDivisionSelectorProps> = ({
  onChange,
  offices,
  value = [],
  disabled = false,
}) => {
  // Get unique divisions from all offices, sorted by name
  const divisions = React.useMemo(() => {
    return offices
      .flatMap((office) => office.divisions)
      .reduce((acc, division) => {
        if (!acc.find((d) => d.id === division.id)) {
          acc.push(division);
        }
        return acc;
      }, [] as DivisionDto[])
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [offices]);

  const divisionData = React.useMemo(() => {
    return divisions.map((division) => ({
      value: division.id.toString(),
      label: division.name,
    }));
  }, [divisions]);

  const handleChange = (selectedValues: string[]) => {
    const selectedDivisions = selectedValues
      .map((id) => divisions.find((d) => d.id.toString() === id))
      .filter((d): d is DivisionDto => d !== undefined);
    onChange(selectedDivisions);
  };

  return (
    <MultiSelect
      data={divisionData}
      value={value.map((v) => v.id.toString())}
      onChange={handleChange}
      disabled={disabled}
      clearable
      searchable
    />
  );
};
